import { FC, createContext, useContext, useState } from "react";

interface InvestDialogProviderProps {
  children: React.ReactNode;
}

export const InvestDialogContext = createContext({
  isShow: false,
  setShowDialog: (_value: boolean) => {},
});

const InvestDialogProvider: FC<InvestDialogProviderProps> = ({ children }) => {
  const [isShow, setShowDialog] = useState(false);
  return (
    <InvestDialogContext.Provider value={{ isShow, setShowDialog: setShowDialog }}>
      {children}
    </InvestDialogContext.Provider>
  );
};

export function useInvestDialog() {
  const context = useContext(InvestDialogContext);
  if (!context) {
    throw new Error("useLoading must be used within InvestDialogProvider");
  }
  return context;
}

export default InvestDialogProvider;